<template>
  <div>
      <img src="../assets/404.jpg" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>